<template>
  <div class="content">
    <div class="loader" v-if="loading">
      <loader/>
    </div>
      <div class="home-texts" v-if="!loading">
        <invest-slider></invest-slider>
        <div>
          <div class="concept-page">
            <div class="container">
              <div class="page">
                <div class="allextras">
                  <div class="actus">
                    <ul class="extras-grid">
                      <li v-for="(invest, index) in invests" :index="index" :key="'_' + invest.id" :item="invest"
                          class="active">
                        <div class="invest-card">
                          <h3 v-if="!invest.invest_texts.title_link">{{invest.invest_texts.title}}</h3>
                          <h3 v-else class="title-with-link">
                            <a :href="invest.invest_texts.title_link" target="_blank">
                              {{invest.invest_texts.title}}
                            </a>
                          </h3>
                          <p :inner-html.prop="invest.invest_texts.content"></p>
                          <div class="white-shadow"></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="button-footer">
                  <a :href="`mailto:${$t('footer.contact.email')}`" class="red-btn colored-btn"><span>{{$t('privacyPro.contact')}}</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../components/loader.component';
  import { mapState } from 'vuex';
  import InvestSlider from './invest-slider';
  import { setBodyConcept } from '../../helpers/body-class.helper';
  import {MetaHelper} from "../../helpers/meta.helper";

  export default {
    name: 'invest',
    components: { InvestSlider, Loader },
    metaInfo() {
      return MetaHelper.invest(this.$store.state.lang.currentLang);
    },
    async created() {
      if (this.$route.params) {
        await this.$store.dispatch('investPage/fetch', this.$route.params);
      }
    },
    computed: mapState({
      loading: state => state.investPage.loading,
      invests: state => state.investPage.invests,
    }),
    async mounted() {
      setBodyConcept();
      await this.$store.dispatch('menu/setIndexActive', 0);
    }
  };
</script>

<style scoped>
  .loader {
    height: 120px;
  }
  .title-with-link a {
    color: var(--darker-orange);
    text-decoration: none;
  }
  .title-with-link a:hover {
    opacity: .85;
  }
  .white-shadow {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 65px;
    background: -moz-linear-gradient(bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);
  }
</style>



// WEBPACK FOOTER //
// src/pages/invest-pro/invest.vue